import { useState } from "react";
import Modal from 'react-bootstrap/Modal';
export default function ModalPopup(props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return <>
            <button className={`${props.btnclass}`} onClick={handleShow}>
                {props.btntext}
            </button>
            <Modal className={`${props.modalclass}`} show={show} onHide={handleClose} >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {props.children}
                </Modal.Body>
            </Modal>
    </>
}